import React from 'react';
import { IonContent, IonPage, useIonRouter } from '@ionic/react';
import { useAlert } from 'utils/alert';
import { RouteComponentProps } from 'react-router';
import { Form, Input } from 'antd';
import { Button } from 'react-bootstrap';
import { analytics, axius, env, func, types } from 'utils';
import { Header, IonLoading, PhoneNumber } from 'components';
import { _store, _update } from '_Store';

interface Props extends RouteComponentProps, types.StateProps {}
const Login: React.FC<Props> = (props) => {
	const {
		__data: {
			settings: { countries },
			location,
			cart,
		},
	} = _store.useState();

	const [form] = Form.useForm();

	const [vv, setValues] = React.useState({
		type: 'AARIN',
		code: '',
		username: '',
		password: '',
	});
	const [code, setCode] = React.useState(false);
	const [count, setCount] = React.useState(0);
	const [loading, setLoading] = React.useState('');

	const [presentAlert] = useAlert();
	const router = useIonRouter();

	React.useEffect(() => {
		if (env.NODE_ENV === 'local') {
			form.setFieldsValue({
				country: 'GH',
				password: 'space123',
				phoneNumber: '0262988710',
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const resendCountdown = () => {
		setCount(0);
		let timer = setInterval(() => {
			setCount((caunt) => caunt + 1);
		}, 1 * 1000);
		return () => {
			clearInterval(timer);
		};
	};

	const submit = (v: any) => {
		if (v.code) {
			submitCode(v);
		} else {
			submitLogin(v);
		}
	};

	const submitLogin = (v: any) => {
		setCount(0);
		setLoading('authenticating...');
		v['username'] =
			vv.username ||
			`+${countries?.find((loc) => loc.code === (v.country || 'NG').toUpperCase())?.callingCode}${v.phoneNumber.replace(/^0/, '')}`;
		axius.post('auth', { ...vv, ...v }).then((res: types.AxiusResponse) => {
			if (res.status === 201) {
				setCode(true);
				setValues((sv) => ({ ...sv, ...v }));
				resendCountdown();
			} else {
				presentAlert(res.message);
			}
			setLoading('');
		});
	};

	const submitCode = (v: any) => {
		setLoading('authenticating...');
		axius
			.post('auth/token', { ...vv, ...v })
			.then((res: types.AxiusResponse) => {
				if (res.status === 201) {
					_update.auth('user', res.data, () => {
						_update.auth('token', res.token, () => {
							if (location.address.x) {
								props.history.replace(
									cart.items.length > 0 ? '/cart' : '/home'
								);
								window.location.reload();
							} else {
								func.setStorage('after_login', 'yes');
								router.push('/location');
							}
							analytics.trackEvent(analytics.eventTypes.SIGN_IN);
							setLoading('');
						});
					});
					func.init();
				} else {
					presentAlert(res.message);
					setLoading('');
				}
			});
	};

	return (
		<IonPage id="Login" className="ph-no-capture">
			<Header
				{...props}
				showBack={false}
				showSearch={false}
				showSegments={false}
				showAddress={false}
			/>
			<IonContent fullscreen={false}>
				<IonLoading
					open={loading ? true : false}
					message={loading}
					onCancel={() => setLoading('')}
				/>

				<div className="p-3">
					{/* <img
						src={images.Logo}
						alt="Republic Dash"
						style={{ width: 50 }}
						className="mb-2"
					/> */}
					<h3 className="mb-0">
						<b>Welcome Back!</b>
					</h3>
					{/* <div>&nbsp;</div> */}
					<Form
						form={form}
						layout="vertical"
						onFinish={submit}
						className="mt-4s"
					>
						{code ? (
							<div>
								<div className="mb-5">
									One time code has been sent to{' '}
									<span className="primary">
										{func.format.phoneNumber(vv.username)}
									</span>
									.
								</div>
								<Form.Item name="code" rules={[func.requiredInput]}>
									<Input
										type="number"
										size="large"
										className="text-center"
										placeholder="• • • • • •"
										style={{ letterSpacing: 10 }}
									/>
								</Form.Item>
								<div>&nbsp;</div>

								<Button type="submit" variant="secondary btn-block btn-md">
									Verify &amp; Continue
								</Button>
								<div>&nbsp;</div>

								<div className="text-center">
									Didn't get the code?{' '}
									{count < 60 ? (
										`Resend in ${60 - count} secs`
									) : (
										<b onClick={() => submitLogin({})}>Resend now</b>
									)}
									.
								</div>
							</div>
						) : (
							<>
								<div className="text-muted mb-5">Log in to your account.</div>
								<PhoneNumber {...props} form={form} />
								<div>&nbsp;</div>

								<Button
									type="submit"
									variant="secondary btn-block btn-md text-uppercases"
								>
									Sign in
								</Button>
								<div>&nbsp;</div>

								<div
									className="text-centers mt-2 text-muted small"
									onClick={() => router.push('/signup')}
								>
									Don't have account?&nbsp; <b className="primary">Sign up</b>
								</div>
							</>
						)}
					</Form>
				</div>
				<div>&nbsp;</div>
				<div>&nbsp;</div>
				<div>&nbsp;</div>
			</IonContent>
		</IonPage>
	);
};

export default Login;
